import {FaFileInvoiceDollar, FaGasPump, FaMoneyBillWave, FaTools} from "react-icons/fa";
import { FaBuilding, FaRegBuilding, FaUsersGear } from "react-icons/fa6";
import { LuBoxes } from "react-icons/lu";
import { PiCar, PiFolder, PiPackage,PiTruck } from "react-icons/pi";
import { RiCalendarScheduleLine } from "react-icons/ri";
import { TbRoute } from "react-icons/tb";
import { HeaderMenuItem } from "../type/menu-type";
import {IoStatsChart, IoSettingsOutline} from "react-icons/io5";




export const menuRoutes = {
    auth: {
        login: "/login",
        forgot_password: "/forgot-password",
        reset_password: "/reset-password",
        change_password: "/change-password",
    },
    organisations: {
        path: "/companies",
        create: "create",
        edit: ":id/edit",
    },
    roles: {
        path: "/roles",
        create: "create",
        edit: ":id/edit",
    },
    dashboard: {
        path: "/dashboard",
    },
    providers: {
        path: "/providers",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile/",
            info: "info",
            headquarters: "headquarters",
        }
    },
    stockMovements: {
        path: "/stock-movements",
        create: "create",
        edit: ":id/edit",
    },
    providerTypes: {
        path: "/provider-types",
        create: "create",
        edit: ":id/edit"
    },
    headquarters: {
        path: "/headquarters",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile/",
            info: "info",
            products: "products",
            pickups: "pickups",
            assets: "assets",
        }
    },
    products: {
        path: "/products",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile/",
            info: "info",
            stockMovements: "stock-movements",
        }
    },
    categories: {
        path: "/categories",
        create: "create",
        edit: ":id/edit",
    },
    units: {
        path: "/units",
        create: "create",
        edit: ":id/edit",
    },
    users: {
        path: "/users",
        create: "create",
        edit: ":id/edit/info",
        edit_permissions: ":id/edit/permissions",
        profile: {
            path: ":id/profile/",
            info: "info",
            documents: "documents",
            permissions: "permissions",
        },
    },
    workHours: {
        path: "/work-hours",
        create: "create",
        edit: ":id/edit",
    },
    vehicles: {
        path: "/vehicles",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile/",
            info: "info",
            refueling: "refueling",
            maintenance: "maintenance",
        }
    },
    maintenances: {
        path: "/maintenances",
        create: "create",
        edit: ":id/edit",
    },
    providersInvoices: {
        path: "/providers-invoices",
        create: "create",
        edit: ":id/edit",
        listAuto: "list-auto",
        profile: {
            path: ":id/profile/",
            info: "info",
        }
    },
    refuels: {
        path: "/refuels",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile/",
            info: "info",
        }
    },
    routes: {
        path: "/routes",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile/",
            info: "info",
            headquarters: "headquarters",
        }
    },
    pickups: {
        path: "/pickups",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile/",
            info: "info",
            products: "products",
            statusHistory: "status-history",
        }
    },
    pickupProducts: {
        path: "/pickup-products",
        create: "create",
        edit: ":id/edit",
    },
    myPickups: {
        path: "my-pickups"
    },
    pickupsMessages: {
        path: "/pickups-global-messages",
        create: "create",
        edit: ":id/edit",
    },
    clients: {
        path: "/clients",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile/",
            info: "info",
            invoices: "invoices",
            proformas: "proformas",
            facturas: "facturas",
        }
    },
    invoices: {
        path: "/invoices",
        proformas: "/proformas",
        facturas: "/facturas",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile/",
            info: "info"
        }
    },
    generalExpenses: {
        path: "/general-expenses",
        create: "create",
        edit: ":id/edit",
    },
    config: {
        path: "/config",
        create: "create",
        edit: ":id/edit",
    }
};

export const menuItems: HeaderMenuItem = {
    administrationMenu: {
        id: "administration",
        name: "Administración",
        path: "/admin",
        react_icon: PiFolder,
        type: "enhance",
        items: [
            {
                id: "dashboard",
                name: "Dashboard",
                path: menuRoutes.dashboard.path,
                react_icon: IoStatsChart,
                permissions_required: [
                    {
                        group: "dashboard",
                        action: "get",
                    }
                ],
            },
            {
                id: "access-and-credentials",
                name: "Control de acceso",
                path: "",
                react_icon: FaUsersGear,
                subMenuItems: [
                    {
                        name: "Usuarios",
                        href: menuRoutes.users.path,
                        icon: "FolderIcon",
                        permissions_required: [
                            {
                                group: "user",
                                action: "list",
                            }
                        ],
                    },
                    {
                        name: "Roles",
                        href: menuRoutes.roles.path,
                        icon: "RolesIcon",
                        permissions_required: [
                            {
                                group: "role",
                                action: "list",
                            },
                        ],
                    },
                ],
            },
            {
                id: "work-hours",
                name: "Horas Trabajadas",
                path: menuRoutes.workHours.path,
                react_icon: RiCalendarScheduleLine,
                permissions_required: [
                    {
                        group: "work_hour",
                        action: "admin",
                    },
                ],
            },
            {
                id: "providers",
                name: "Proveedores",
                path: "",
                react_icon: PiPackage,
                subMenuItems: [
                    {
                        name: "Proveedores",
                        href: menuRoutes.providers.path,
                        permissions_required: [
                            {
                                group: "provider",
                                action: "list",
                            }
                        ],
                    },
                    {
                        name: "Tipos de Proveedores",
                        href: menuRoutes.providerTypes.path,
                        permissions_required: [
                            {
                                group: "provider_type",
                                action: "list",
                            }
                        ],
                    },
                    {
                        name: "Facturación",
                        href: menuRoutes.providersInvoices.path,
                        permissions_required: [
                            {
                                group: "provider_invoicing",
                                action: "list",
                            }
                        ],
                    }
                ]
            },
            {
                id: "headquarters",
                name: "Sedes",
                path: menuRoutes.headquarters.path,
                react_icon: FaBuilding,
                permissions_required: [
                    {
                        group: "headquarter",
                        action: "list",
                    }
                ],
            },
            {
                id: "routes",
                name: "Rutas",
                path: menuRoutes.routes.path,
                react_icon: TbRoute,
                permissions_required: [
                    {
                        group: "route",
                        action: "list",
                    }
                ],
            },
            {
                id: "vehicles",
                name: "Vehículos",
                path: "",
                react_icon: PiCar,
                subMenuItems: [
                    {
                        name: "Vehículos",
                        href: menuRoutes.vehicles.path,
                        permissions_required: [
                            {
                                group: "vehicle",
                                action: "list",
                            }
                        ],
                    },
                    {
                        name: "Mantenimientos",
                        href: menuRoutes.maintenances.path,
                        permissions_required: [
                            {
                                group: "maintenance",
                                action: "list",
                            }
                        ],
                    },
                    {
                        name: "Repostajes",
                        href: menuRoutes.refuels.path,
                        permissions_required: [
                            {
                                group: "refuel",
                                action: "list",
                            }
                        ],
                    }
                ]
            },
            {
                id: "pickups",
                name: "Recogidas",
                path: "",
                react_icon: PiTruck,
                subMenuItems: [
                    {
                        name: "Recogidas",
                        href: menuRoutes.pickups.path,
                        permissions_required: [
                            {
                                group: "pickup",
                                action: "list",
                            }
                        ],
                    },
                    {
                        name: "Mis recogidas",
                        href: menuRoutes.myPickups.path,
                        permissions_required: [
                            {
                                group: "pickup",
                                action: "driver"
                            },
                            {
                                group: "pickup",
                                action: "view_assigned"
                            }
                        ],
                    },
                    {
                        name: "Mensajes",
                        href: menuRoutes.pickupsMessages.path,
                        permissions_required: [
                            {
                                group: "pickup_global_messages",
                                action: "list",
                            }
                        ],
                    },
                ]
            },
            {
                id: "products",
                name: "Productos",
                path: "",
                react_icon: LuBoxes,
                subMenuItems: [
                    {
                        name: "Productos",
                        href: menuRoutes.products.path,
                        permissions_required: [
                            {
                                group: "product",
                                action: "list",
                            }
                        ],
                    },
                    {
                        name: "Categorias",
                        href: menuRoutes.categories.path,
                        permissions_required: [
                            {
                                group: "category",
                                action: "list",
                            }
                        ],
                    },
                    {
                        name: "Unidades de Medida",
                        href: menuRoutes.units.path,
                        permissions_required: [
                            {
                                group: "unit_measure",
                                action: "list",
                            }
                        ],
                    },
                    {
                        name: "Movimientos de Stock",
                        href: menuRoutes.stockMovements.path,
                        permissions_required: [
                            {
                                group: "stock_movements",
                                action: "list",
                            }
                        ],
                    },
                ]
            },
            {
                id: "clients",
                name: "Ventas de clientes",
                path: "",
                react_icon: FaFileInvoiceDollar,
                subMenuItems: [
                    {
                        name: "Clientes",
                        href: menuRoutes.clients.path,
                        permissions_required: [
                            {
                                group: "client",
                                action: "list",
                            }
                        ]
                    },
                    {
                        name: "Proformas",
                        href: menuRoutes.invoices.proformas,
                        permissions_required: [
                            {
                                group: "invoice",
                                action: "list",
                            }
                        ]
                    },
                    {
                        name: "Facturas",
                        href: menuRoutes.invoices.facturas,
                        permissions_required: [
                            {
                                group: "invoice",
                                action: "list",
                            }
                        ]
                    }
                ]
            },
            {
                id: "general-expenses",
                name: "Gastos Generales",
                path: menuRoutes.generalExpenses.path,
                react_icon: FaMoneyBillWave,
                permissions_required: [
                    {
                        group: "general_expense",
                        action: "list",
                    }
                ],
            },
            {
                id: "config",
                name: "Configuración",
                path: menuRoutes.config.path,
                react_icon: IoSettingsOutline,
                permissions_required: [
                    {
                        group: "config",
                        action: "list",
                    }
                ],
            },
        ]
    },

    superAdminMenu: {
        id: "title-super-admin",
        name: "Panel Administración",
        icon: "GreenLeafIcon",
        react_icon: PiFolder,
        type: "enhance",
        columns: "1",
        permissions_required: [
            {
                group: "company",
                action: "admin",
                isSuperAdmin: true,
            },
        ],
        items: [
            {
                id: "organisations",
                name: "Organizaciones",
                path: menuRoutes.organisations.path,
                react_icon: FaRegBuilding,
                permissions_required: [
                    {
                        group: "company",
                        action: "admin",
                        isSuperAdmin: true,
                    },
                ],
            },
            // {
            //     id: "roles",
            //     name: "Roles",
            //     path: menuRoutes.roles.path,
            //     react_icon: RiShieldKeyholeLine,
            //     permissions_required: [
            //         {
            //             group: "role",
            //             action: "admin",
            //             isSuperAdmin: true,
            //         },
            //     ],
            //     subMenuItems: [
            //         {
            //             name: "Lista Roles",
            //             href: menuRoutes.roles.path,
            //             permissions_required: [
            //                 {
            //                     group: "role",
            //                     action: "list",
            //                 }
            //             ],
            //         },
            //         {
            //             name: "Crear Rol",
            //             href: menuRoutes.roles.path + '/' + menuRoutes.roles.create,
            //             permissions_required: [
            //                 {
            //                     group: "role",
            //                     action: "create",
            //                 }
            //             ],
            //         },
            //     ]
            // },
        ],
    },

};